import { isFetchResultSuccessful } from '../../entities/FetchResult'
import {
    NotificationCenterAction,
    NotificationCenterActionCategory,
    NotificationCenterCategory,
} from '../../entities/NotificationCenter/NotificationCenter'
import { endEventLoggerApiCall, startEventLoggerApiCall } from '../../entities/NotificationCenter/NotificationCenterService'
import { ValkTalkPostFormData } from '../../entities/ValkTalkPost/ValkTalkPost'
import { patchValkTalkPostApiCall, postValkTalkPostApiCall } from '../../entities/ValkTalkPost/ValkTalkPostService'
import { TypedDispatch } from '../store'
import { setSavedPost } from '../valkTalkPosts/valkTalkPostsReducer'
import {
    setError,
    setIsSuccessful,
    setIsUpdating,
} from './valkTalkPostReducer'

export const saveValkTalkPost = (
    formData: ValkTalkPostFormData,
    postId?: string,
) => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsUpdating(true))
    dispatch(setIsSuccessful(false))
    dispatch(setError(''))

    const responseTracker = await startEventLoggerApiCall(
        NotificationCenterCategory.FEED_MESSAGE,
        postId ? NotificationCenterAction.UPDATED : NotificationCenterAction.CREATED,
        [NotificationCenterActionCategory.UNKNOWN],
    )

    if (! isFetchResultSuccessful(responseTracker)) {
        dispatch(setError(responseTracker.error))
        dispatch(setIsUpdating(false))

        return
    }

    try {
        const response = postId
            ? await patchValkTalkPostApiCall(postId, formData, responseTracker.data)
            : await postValkTalkPostApiCall(formData, responseTracker.data)

        if (! isFetchResultSuccessful(response)) {
            dispatch(setError(response.error))

            return
        }

        dispatch(setSavedPost(response.data))
        dispatch(setIsSuccessful(true))
    } catch (error) {
        console.error('[saveValkTalkPost]', error)
    } finally {
        await endEventLoggerApiCall(responseTracker.data)
        dispatch(setIsUpdating(false))
    }
}
